module.exports = __webpack_public_path__ + "static/gq-spend-get-dec-web-homepage-banner-gemvnz-mobile-c2cd9483ca287e5cc2478b3620b7c284.webp";